// extracted by mini-css-extract-plugin
module.exports = {"middleWrapper":"middleContent_middleWrapper__xHyMG"};